// extracted by mini-css-extract-plugin
export default {"page":"Placeholder_page__g696W","inner":"Placeholder_inner__dIRRb","title":"Placeholder_title__H0u4w","message":"Placeholder_message__UX+vH","back":"Placeholder_back__F1K5e"};